<section id="filterContainer">
    <div class="p-8">
        <article>
            <h1 class="title">{{ literalService.get('filterBy', true) }}</h1>
        </article>
        <article class="lg:flex sm:relative place-content-between">
            <div class="flex items-center mt-8">
                <div class="flex justify-center text-center w-48">
                    <label class="font-semibold primary-purple-light-text">{{ literalService.get('availabilities.filter.dates', true) }}</label>
                </div>
                <div class="flex justify-center ml-6 text-center w-48">
                    <label class="font-semibold primary-purple-light-text">{{ literalService.get('availabilities.filter.times', true) }}</label>
                </div>
                <div class="flex justify-center ml-6 text-center w-48">
                    <label class="font-semibold primary-purple-light-text">{{ literalService.get('availabilities.filter.status', true) }}</label>
                </div>
                <div class="flex justify-center ml-6 text-center w-48">
                    <label class="font-semibold primary-purple-light-text">{{ literalService.get('availabilities.filter.bookings', true) }}</label>
                </div>
            </div>
        </article>
        <article class="lg:flex sm:relative place-content-between mt-2">
            <div class="flex">
                <div class="justify-center text-center w-48">
                    <app-calendar class="flex mb-2" [id]="'startDate'" [title]="'startDate'" [value]="fromDate" [allDays]="true" (change)="changeDate($event, 'from')" />
                    <app-calendar class="flex mb-2" [id]="'endDate'" [title]="'endDate'" [value]="toDate" [allDays]="true" (change)="changeDate($event, 'to')" />
                </div>
                <div class="justify-center ml-6 text-center w-48">
                    <input type="time" [value]="startTime" class="flex mb-2 w-48 h-12 px-3 py-2 bg-white border rounded-s rounded-e font-normal placeholder-slate-400 focus:outline-none" (change)="changeTime($event, 'start')" autocomplete="one-time-code" />
                    <input type="time" [value]="endTime" class="flex mb-2 w-48 h-12 px-3 py-2 bg-white border rounded-s rounded-e font-normal placeholder-slate-400 focus:outline-none" (change)="changeTime($event, 'end')" autocomplete="one-time-code" />
                </div>
                <div class="justify-center ml-6 text-center w-48">
                     @for (status of status; track $index) {
                        <label class="flex box py-2 px-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer bg-white">
                            <input type="checkbox" class="mr-2 cursor-pointer" [checked]="status.checked" (change)="status.checked = !status.checked"/>
                            {{ literalService.get('trips.' + status.value.toLowerCase(), true) }}
                        </label>
                    }
                </div>
                <div class="justify-center ml-6 text-center w-48">
                     @for (booking of bookings; track $index) {
                        <label class="flex box py-2 px-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer bg-white">
                            <input type="checkbox" class="mr-2 cursor-pointer" [checked]="booking.checked" (change)="booking.checked = !booking.checked"/>
                            {{ literalService.get('availabilities.bookings.' + booking.value.toLowerCase(), true) }}
                        </label>
                    }
                </div>
            </div>
        </article>
        <form #form novalidate (ngSubmit)="onSubmit()">
            <article class="lg:flex sm:relative">
                
            </article>
            <article class="">
                <article class="flex pt-5 place-content-between">
                    <div class="flex">
                        <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer">
                            <input #select id="selectAll" type="checkbox" class="mr-2 cursor-pointer" (change)="selectAll($event)" />
                            {{ literalService.get('selectAll', true) }}
                        </label>
                        <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center bg-white cursor-pointer" (click)="clearSelection()">
                            <img class="mr-1 cursor-pointer" [src]="images.booking.actions.delete" alt="clear" />
                            <label class="cursor-pointer hover:underline">{{ literalService.get('clearSelection', true) }}</label>
                        </article>
                    </div>
                    <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center">
                        <input type="submit" class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-48 uppercase cursor-pointer" [value]="literalService.get('filter', true)" />
                    </article>
                </article>
            </article>
        </form>
    </div>
</section>

